import { MetaTags } from "react-meta-tags"
import Banner from "../../components/Banner"
import Programs from "../../components/Programs"
import ogImage from '../../assets/img/banner/background.png'

export default function HomePage() {
    return (
        <>
            <MetaTags>
                <title>Центр обучение маляра-отделочника в спб | Danogips</title>
                <meta name="description" content="Учебный центр компании Danogips проводит обучение от профессионалов по малярным отделочным работам. Курсы маляр рассчитаны как для начинающих, так и для профессионалов." />
                <meta property="og:title" content="Центр обучение маляра-отделочника в спб" />
                <meta property="og:image" content={ogImage} />
            </MetaTags>
            <Banner />
            <Programs />
        </>
    )
}